var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAvatarPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0001 12.3231C17.4641 12.3231 19.4616 10.3256 19.4616 7.86153C19.4616 5.39749 17.4641 3.39999 15.0001 3.39999C12.536 3.39999 10.5385 5.39749 10.5385 7.86153C10.5385 10.3256 12.536 12.3231 15.0001 12.3231ZM17.8554 7.86153C17.8554 9.43852 16.577 10.7169 15.0001 10.7169C13.4231 10.7169 12.1447 9.43852 12.1447 7.86153C12.1447 6.28455 13.4231 5.00615 15.0001 5.00615C16.577 5.00615 17.8554 6.28455 17.8554 7.86153Z",
    fill: "#00B956"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31606 15.7125L8.75391 16.0296L10.2946 26.6H19.6639L21.2462 16.0296L20.7361 15.6932C19.4788 14.9452 18.0717 14.45 16.6062 14.2329C16.077 14.1545 15.5402 14.1124 15.0001 14.1077C12.9807 14.1447 11.0124 14.7004 9.31606 15.7125ZM19.5007 16.8412C18.1413 16.123 16.5949 15.7312 15.0078 15.714C13.4128 15.7466 11.8624 16.1536 10.5019 16.886L11.6836 24.9938H18.2802L19.5007 16.8412Z",
    fill: "#00B956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/user-avatar-placeholder.0fd35377a8915fde2e11664d4e84d1b9.svg";
export { ForwardRef as ReactComponent };